module.exports = __webpack_public_path__ + "img/megafon-logo-start.0707c8b9.svg";